const micheliniStyles = 'padding: 10px; color: #fff; background-color: #ff2c2c;'
const carrettiStyles = 'padding: 10px; color: #fff; background-color: #000;'

console.log( 'Developed by')
console.log('%cfrancescomichelini.com', micheliniStyles)
console.log('and')
console.log('%ccrrtt.com', carrettiStyles)
console.log('')
